import React, { useRef } from 'react';
import { Link, Redirect, Rout, useHistory } from 'react-router-dom';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  InteractionItem
} from 'chart.js';
import { Bar, getElementAtEvent } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
)

const BarChart = ({ group }) => {

  let title = "";
  let labels = [];

  switch (group) {
    // Graficas por año
    case 'honda':
      title = 'Grupo - Honda';
      labels = ['Honda Tijuana', 'Honda Mexicali', 'Honda Ensenada'];
      break;

    case 'kia':
      title = 'Grupo - Tijuana';
      labels = ['Kia Tijuana', 'Kia Mexicali', 'Kia Ensenada'];
      break;
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: title
      }
    }
  }

  const data = {
    labels,
    datasets: [
      {
        id: '1',
        label: 'Ventas 2022',
        data: labels.map(() => Math.random() * 100),
        backgroundColor: 'rgba(255, 99, 132, 0.5)'
      },
      {
        id: '2',
        label: 'Plan de ventas 2022',
        data: labels.map(() => Math.random() * 100),
        backgroundColor: 'rgba(53, 162, 135, 0.5)'
      },
      {
        id: '3',
        label: 'Ventas 2021',
        data: labels.map(() => Math.random() * 100),
        backgroundColor: 'rgba(53, 162, 135, 0.5)'
      },
    ]
  }

  const chartRef = useRef();
  const navigate = useHistory();

  const printEementAtEvent = (element: InteractionItem[]) => {

    if (!element.length) return;

    const { datasetIndex, index } = element[0];
    let valor = "";
    let path = {};

    switch (data.labels[index]) {
      case 'Honda Tijuana':
        valor = "honda_tijuana";
        break;

      case 'Honda Mexicali':
        valor = "honda_mexicali";
        break;

      case 'Honda Ensenada':
        valor = "honda_ensenada";
        break;

      case 'Kia Tijuana':
        valor = "kia_tijuana";
        break;

      case 'Kia Mexicali':
        valor = "kia_mexicali";
        break;

      case 'Kia Ensenada':
        valor = "kia_ensenada";
        break;
    }

    path = { pathname: '/test_chart/MonthStatistics', params: valor }
    navigate.push(path);
  }

  const onClick = (event: MouseEvent<HTMLCanvasElement>) => {
    const { current: chart } = chartRef;

    if (!chart) return;

    printEementAtEvent(getElementAtEvent(chart, event));
  }

  return (
    <Bar
      style={{ height: '50vh' }}
      options={options}
      data={data}
      ref={chartRef}
      onClick={onClick}
    />
  )
}

export default BarChart;